<template lang="pug">
  div
    h6 批次取藥清單        
    hr
    form.form-inline.mb-2(@submit.prevent="onFilterSet")
      input.form-control.mr-2.w-25(type="text" v-model="queryString" placeholder="輸入藥碼、料位號、學名或病歷號查詢")
      button.btn.btn-primary(type="submit") 搜尋
    vuetable(ref="vuetable"
      :api-url="`${server}/api/fetch-schedule/`"
      data-path="results"
      pagination-path=""
      :fields="fields"
      :per-page="30"
      :api-mode="true"
      :css="boostrapCss"
      :http-options="httpOptions"
      :append-params="moreParams"
      @vuetable:pagination-data="onPaginationData")
    vuetable-pagination(
        ref="pagination"
        :css="boostrapCss.pagination"
        @vuetable-pagination:change-page="onChangePage"
      )
    button.btn.btn-danger.btn-sm.mt-2(@click="deleteSchedule") 刪除選擇藥單
    hr
    div
      input(type="file" id="batch-file-input")
      button.btn.btn-info.btn-sm(@click="uploadFile") 上傳批次檔
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';
import { error } from 'util';

export default {
  name: 'FetchScheduleList',
  data() {
    return {
      moreParams: {},
      queryString: '',
      boostrapCss: {
        tableClass: 'table table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      server,
      fields: [
        {
          name: '__checkbox',
        },
        {
          name: 'medication.code',
          title: '藥碼',
        },
        {
          name: 'medication.CGMH_number',
          title: '料位號',
        },
        {
          name: 'medication.generic_name',
          title: '學名',
        },
        {
          name: 'patient.med_record_number',
          title: '病歷號',
        },
        {
          name: 'amount',
          title: '取藥量',
        },
        {
          name: 'fetch_date',
          title: '取藥日期',
        },
        // {
        //   name: '__component:action',
        //   title: '動作',
        //   titleClass: 'width-100',
        // },
      ],
    };
  },
  components: {
    Vuetable,
    VuetablePagination,
  },
  computed: {
    instance() {
      return this.$store.getters.instance;
    },
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet() {
      this.moreParams = {
        search: this.queryString,
      };
      const vm = this;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    deleteSchedule() {
      const selected = this.$refs.vuetable.selectedTo;
      if (selected.length !== 0) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '刪除藥單中...',
          confirm: false,
        });
        const promises = [];
        selected.forEach((id) => {
          promises.push(this.instance.delete(`/api/fetch-schedule/${id}/`));
        });
        axios.all(promises)
        .then((res) => {
          this.$refs.vuetable.refresh();
          this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '刪除成功',
          });
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請至少選擇一項藥單',
          confirm: true,
        });
      }
      this.$refs.vuetable.selectedTo = [];
    },
    uploadFile() {
      if (document.getElementById('batch-file-input').files.length !== 0) {
        this.$store.commit('SET_MESSAGE', { type: 'warn', context: '上傳資料處理中', confirm: false });
        const form = new FormData();
        form.append('file', document.getElementById('batch-file-input').files[0]);
        this.$store.getters.instance.post('/upload-to-fetch_schedule/', form, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          timeout: 60000,
        })
        .then((res) => {
          let context = '<p>上傳成功</p>';
          if (res.data.loaded_perscription !== undefined) {
            context += `<p>匯入藥單數: ${res.data.loaded_perscription}</p>`;
          }
          if (res.data.total_perscription !== undefined) {
            context += `<p>總藥單數: ${res.data.total_perscription}</p>`;
          }
          if (res.data.num_replicated_prescription !== undefined) {
            if (res.data.num_replicated_prescription > 0) {
              res.data.replicated_prescriptions.forEach((item) => {
                context += `<p>未匯入的重複藥單:  ${item}</p>`;
              });
            }
          }
          this.$store.commit('SET_MESSAGE', { type: 'success', context });
          this.$refs.vuetable.refresh();
        })
        .catch((err) => {
          const errorResponse = err.response.data;
          let context = '<p>上傳失敗</p>';
          if (err.response) {
            if (errorResponse.medication_code_not_found !== undefined) {
              if (errorResponse.medication_code_not_found.length > 0) context += `<p>資料庫無此藥碼: ${errorResponse.medication_code_not_found}</p>`;
            }
            // if (errorResponse.decode_error) {
            //   if (errorResponse.decode_error.length > 0) context += `<p>資料有誤行列: ${errorResponse.decode_error}</p>`;
            // }
            if (errorResponse.loaded_perscription !== undefined) context += `<p>匯入藥單數: ${errorResponse.loaded_perscription}</p>`;
            if (errorResponse.total_perscription !== undefined) context += `<p>總藥單數: ${errorResponse.total_perscription}</p>`;
            if (errorResponse.num_replicated_prescription !== undefined) {
              if (errorResponse.num_replicated_prescription > 0) {
                errorResponse.replicated_prescriptions.forEach((item) => {
                  context += `<p>未匯入的重複藥單:  ${item}</p>`;
                });
              }
            }
          }
          this.$store.commit('SET_MESSAGE', { type: 'error', context });
          this.$refs.vuetable.refresh();
        });
      } else {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '請先選擇上傳檔案' });
      }
    },
  },
};
</script>

<style lang="sass">
.width-100
  width: 100px
</style>




// WEBPACK FOOTER //
// FetchScheduleList.vue?69dfbf34